import { createSlice } from '@reduxjs/toolkit';

const petInformation = createSlice({
  name: 'petInformation',
  initialState: {
    isLoading: false,
    petAppointments: {
      active: [],
      past: [],
    },
  },
  reducers: {
    petAppointmentsRequest(state) {
      state.isLoading = true;
    },
    petAppointmentsSuccess(state, { payload }) {
      state.petAppointments = payload.data;
      state.isLoading = false;
    },
    petAppointmentsFailure(state) {
      state.isLoading = false;
    },
  },
});

const { actions, reducer } = petInformation;

export const {
  petAppointmentsRequest,
  petAppointmentsSuccess,
  petAppointmentsFailure,
} = actions;

export default reducer;
